import { PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

import { BasicProps } from '@eastcoal/common/types/component'

const useStyles = createStyles(({ token }) => ({
  container: {
    width: token.layoutContentWidth,
    marginInline: 'auto'
  }
}))

export const LayoutContainer = ({
  className,
  style,
  children
}: PropsWithChildren<BasicProps>) => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.container, className)} style={style}>
      {children}
    </div>
  )
}
